// extracted by mini-css-extract-plugin
export default {"shareButton":"SocialShareButton_shareButton__7mEMx","logoContainer":"SocialShareButton_logoContainer__UuRtR"};